export default __webpack_public_path__ + "static/media/graded.dd69ede3.png";